import { ProjectStagesComponent } from '../../../../shared/govco/project-stages/project-stages.component';
import { FileStorageStatusService } from '../../../../core/services/file-storage-status.service';
import { isFileStorageError } from '../../../../core/utils/file-storage-error';
import type { SectionFile } from '../../../../core/interfaces/http/section-file.interface';
import { ProjectDialogService } from '../../../../core/services/project-dialog.service';
import { ProjectWorkflowProgressService } from '../../../../core/services/project-workflow-progress.service';
import type { Workspace } from '../../../../core/interfaces/backend/proyectos/project-sections.interface';
import { Observable } from 'rxjs';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ProjectSectionsService } from '../../../../services/backend/psa/project-sections.service';
import { ProblemTreeComponent } from '../problem-tree/problem-tree.component';
import { ProjectActorsComponent } from '../project-actors/project-actors.component';
@Component({ standalone: true, providers: [FileStorageStatusService], imports: [ProjectStagesComponent, RouterLink, ProblemTreeComponent, ProjectActorsComponent], templateUrl: './problem-actors.component.html', styleUrl: './problem-actors.component.css' })
export class ProblemActorsComponent implements OnInit {
  readonly progress = inject(ProjectWorkflowProgressService);
  readonly dialogs = inject(ProjectDialogService);
    private readonly api = inject(ProjectSectionsService);
    private readonly route = inject(ActivatedRoute);
    readonly projectId = this.route.snapshot.queryParamMap.get('projectId');
    section: 'problems' | 'actors' = this.route.snapshot.queryParamMap.get('section') === 'actors' ? 'actors' : 'problems';
    workspace?: Workspace;
    dirty = false;
    saving = false;
    readingFile = false;
    readonly storage = inject(FileStorageStatusService);
    get storageUnavailable(){return !this.storage.checking() && !this.storage.available();}
    loading = true;
    error = '';
    notice = '';
    ngOnInit(): void { this.storage.watch(this.projectId);this.progress.refresh(this.projectId);this.load(); }
    load(): void { if (!this.projectId) {
        this.loading = false;
        this.error = 'Seleccione un proyecto desde Mis proyectos para acceder a sus secciones.';
        return;
    } this.api.workspace(this.projectId).subscribe({ next: w => { this.workspace = w; this.loading = false; this.dirty = false; }, error: () => { this.loading = false; this.error = 'No se pudo consultar el proyecto. Verifique sus permisos.'; } }); }
    async change(section: 'problems' | 'actors'): Promise<void> { if (this.saving || this.readingFile || this.section === section)
        return; if (!this.dirty || await this.dialogs.confirm('Hay cambios sin guardar. ¿Desea cambiar de sección y descartarlos?')) {
        this.section = section;
        this.load();
        this.error = '';
        this.notice = '';
    } }
    async save(confirmed = false): Promise<void> {
        if (!this.projectId || !this.workspace || !this.workspace.canEdit || this.saving || this.readingFile || (this.section==='actors' && !this.storage.available() && this.workspace.actorFiles?.some(f=>!!f.contenido)) || (!confirmed && !await this.dialogs.confirm('¿Está seguro que desea guardar los cambios realizados?')))
            return;
        this.saving = true;
        this.error = '';
        this.notice = '';
        const w = this.workspace;
        const request: Observable<unknown> = this.section === 'problems' ? this.api.tree(this.projectId, w.tree, confirmed) : this.api.actors(this.projectId, w.actors, w.actorFiles ?? []);
        request.subscribe({ next: () => {  this.progress.rememberSaved(this.projectId,this.section); this.saving = false; this.dirty = false; this.notice = 'Cambios guardados. Las secciones incompletas deben completarse antes del envío a la AAC.'; this.load();this.progress.refresh(this.projectId);void this.dialogs.success('La información se guardó correctamente. Las secciones con campos pendientes permanecen como borrador.'); }, error: async e => { this.saving = false; if(this.section==='actors' && isFileStorageError(e)){this.storage.failed();this.error='';return;} this.error = e.error?.response?.message ?? 'No se pudo guardar. Revise los campos obligatorios y sus relaciones.'; if(e.status===409 && this.error.includes('dependencias') && !confirmed && await this.dialogs.confirm(this.error+' ¿Desea continuar?')) this.save(true); } });
    }
    downloadActorFile(file: SectionFile): void {
        if (!this.projectId || !file.id_registro || file.contenido || !this.storage.available()) return;
        this.api.downloadActorFile(this.projectId, file.id_registro).subscribe({next: blob => {
             this.error = '';
            const url = URL.createObjectURL(blob); const link = document.createElement('a');
            link.href = url; link.download = file.nombre; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
        }, error: e => { if(isFileStorageError(e)){this.storage.failed();this.error='';}else this.error = 'No se pudo descargar el documento de actores.'; }});
    }
    async cancel(): Promise<void> { if (this.saving || this.readingFile) return; if (await this.dialogs.confirm('¿Está seguro que desea cancelar los cambios realizados?')) {
        this.load();
        this.error = '';
        this.notice = '';
    } }
    @HostListener('window:beforeunload', ['$event'])
    unload(e: BeforeUnloadEvent): void { if (this.dirty) {
        e.preventDefault();
        e.returnValue = '';
    } }
}
